import linkifyElement from 'linkify-element'
import { Opts } from 'linkifyjs'
import { App, Directive } from 'vue'

const baseOptions: Opts = {
  defaultProtocol: 'https',
  target: (_href: string, type: string) => (type === 'email' ? '_self' : '_blank'),
  attributes: (_href: string, type: string) => (type === 'url' ? { rel: 'noopener noreferrer' } : {}),
  ignoreTags: ['script', 'style', 'a'],
  className: (_href: string, type: string) => (type === 'email' ? 'linkify-email' : 'linkify-link'),
  events: {
    click(this: HTMLAnchorElement, e: MouseEvent) {
      const href = this.href

      // Skip confirmation for email links
      if (href.startsWith('mailto:')) {
        return
      }
      // Optional: only warn for third-party (external) links
      try {
        const url = new URL(href, window.location.origin)
        const isExternal = url.hostname !== window.location.hostname

        if (!isExternal) {
          return // allow internal links without confirmation
        }
      } catch {
        // If URL parsing fails, treat as external and ask anyway
      }

      const ok = window.confirm(
        `Are you sure you want to open this external link?\n\n${href}\n\nThis will open in a new tab.`
      )

      if (!ok) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
  },
}

function apply(el: HTMLElement, binding: { value?: Opts }) {
  const opts: Opts = { ...baseOptions, ...(binding?.value || {}) }
  linkifyElement(el, opts)
}

export const vLinkify: Directive<HTMLElement, Opts | undefined> = {
  mounted(el, binding) {
    apply(el, binding)
  },
  updated(el, binding) {
    apply(el, binding)
  },
}

export function setupLinkifyDirective(app: App<Element>) {
  app.directive('linkify', vLinkify)
}
